import { render, staticRenderFns } from "./UserPolicies.vue?vue&type=template&id=0b541afc&scoped=true&"
import script from "./UserPolicies.vue?vue&type=script&lang=js&"
export * from "./UserPolicies.vue?vue&type=script&lang=js&"
import style0 from "./UserPolicies.vue?vue&type=style&index=0&id=0b541afc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b541afc",
  null
  
)

export default component.exports